import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['element', 'switch'];

  toggle(event) {
    if (event.currentTarget.classList.contains('is-active')) {
      return false;
    }

    this.elementTargets.forEach(el => el.classList.remove('is-active'));
    this.switchTargets.forEach(el => el.classList.remove('is-active'));
    this.element.querySelectorAll('[data-controller="shared--odometer"]').forEach(element => {
      element.innerHTML = 0;
    });

    event.currentTarget.classList.toggle('is-active');
    this.element.querySelector(`.${event.currentTarget.dataset.element}`).classList.add('is-active');

    this.element.querySelectorAll('.is-active [data-controller="shared--odometer"]').forEach(element => {
      element.innerHTML = element.dataset['shared-OdometerValue'];
    });
  }
}
